import lottie from 'lottie-web';

export default class LottieHandler {
    constructor() {
        const elements = document.querySelectorAll('[data-w-lottie]');

        elements.forEach((element, index) => {
            const animation = lottie.loadAnimation({
                name: 'lottie_' + index,
                container: element,
                renderer: 'svg',
                loop: element.getAttribute('data-w-lottie-loop') === 'true',
                autoplay: false,
                path: element.getAttribute('data-w-lottie'),
                rendererSettings: {
                    filterSize: {
                        width: '500%',
                        height: '500%',
                        x: '-200%',
                        y: '-200%',
                    },
                },
            });
            element.lottie = animation;
            animation.addEventListener('data_ready', () => {
                element.classList.add('w-is-lottie-loaded');
            });
        });

        document.addEventListener(
            'w.InViewHandler.enterLottie',
            (event) => {
                if (event.detail.lottie) {
                    event.detail.lottie.play();
                }
            },
            false
        );
    }
}
